import type { Event } from "../api/types";

interface Props {
  events: Event[];
}

export function EventsSection({ events }: Props) {
  if (events.length === 0) return null;

  return (
    <section className="events-section">
      <h3 className="events-heading">Events this week</h3>
      <ul className="events-grid">
        {events.map((event) => (
          <li key={event.event_id} className="event-card">
            {event.image_url && (
              <img
                src={event.image_url}
                alt=""
                className="event-image"
                loading="lazy"
              />
            )}
            <div className="event-body">
              <span className="event-name">{event.name}</span>
              <div className="event-meta">
                {event.date && (
                  <span className="event-date">{event.date}</span>
                )}
                {event.venue_name && (
                  <span className="event-venue muted">
                    {event.venue_name}
                  </span>
                )}
              </div>
              <div className="event-footer">
                {event.price && (
                  <span className="event-price">{event.price}</span>
                )}
                {event.ticket_url && (
                  <a
                    href={event.ticket_url}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="event-tickets"
                  >
                    Tickets
                  </a>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
